import { RoutesConfig } from 'src/app/configs/routes.config';
import { MeetingsRoutes } from 'src/app/pages/meetings/models/routes';
import { BookingRoutes } from '../../../models/bookings.model';

export interface ISideMenuItem {
  name: string;
  active: boolean;
  route: string;
  iconClass?: string;
  expanded?: boolean;
  children?: Omit<ISideMenuItem, 'children' | 'expanded'>[];
}

export const MENU_ITEMS: ISideMenuItem[] = [
  {
    name: 'Translation.Fas',
    route: `/${RoutesConfig.pages.findSpace}`,
    active: false,
    iconClass: 'icon-fas-24',
  },
  {
    name: 'Translation.Calendar',
    route: `/${RoutesConfig.pages.calendar}`,
    active: false,
    iconClass: 'icon-calendar-default-24',
  },
  {
    name: 'Translation.Meetings',
    route: RoutesConfig.pages.meetings,
    active: false,
    iconClass: 'icon-meeting-24',
    children: [
      {
        name: 'Translation.Meetingsdashboard',
        route: `/${RoutesConfig.pages.meetings}/${MeetingsRoutes.dashboard}`,
        active: false,
      },
      // Phase - 1 Hiding option for unfulfilled dashboard
      {
        name: 'Translation.Meeting_request',
        route: `/${RoutesConfig.pages.meetings}/${MeetingsRoutes.requests}/${MeetingsRoutes.dashboard}`,
        active: false,
      },
      // {
      //   name: 'Translation.Unfulfilledteam',
      //   route: `/${RoutesConfig.pages.meetings}/${MeetingsRoutes.unfulfilledRequests}`,
      //   active: false,
      // },
    ],
  },
  {
    name: 'Translation.Bookings',
    route: `/${RoutesConfig.pages.bookings}`,
    active: false,
    iconClass: 'icon-booking-24',
    children: [
      {
        name: 'Translation.Allbookings',
        route: `/${RoutesConfig.pages.bookings}/allBookings/${BookingRoutes.dashboard}`,
        active: false,
      },
      {
        name: 'Translation.Waitlist',
        route: `/${RoutesConfig.pages.bookings}/${BookingRoutes.waitlist}`,
        active: false,
      },
    ]
  },
  {
    name: 'Translation.Serviceorders',
    route: `/${RoutesConfig.pages.serviceOrders}`,
    active: false,
    iconClass: 'icon-request-24',
  }
];
